import { Chip } from "@mui/material";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  REQUIRED_SECTION_COLORS,
  REQUIRED_SECTION_LABELS,
} from "../initial-f2f-required-constant";
import { RequiredSectionItem } from "../initial-f2f-types";

export interface RequiredSectionsSummaryProps {
  /** Required sections found empty at the last Save & Sign, in note order. */
  missing: RequiredSectionItem[];
  onSelectSection: (key: string) => void;
}

const RequiredSectionsSummary = ({
  missing,
  onSelectSection,
}: RequiredSectionsSummaryProps) => {
  if (!missing.length) return null;
  return (
    <Flex alignItems="center" gap={1} flexWrap="wrap" px={1.5} py={0.5}>
      <Text isTabletext c={REQUIRED_SECTION_COLORS.required}>
        {REQUIRED_SECTION_LABELS.fillBefore}
      </Text>
      {missing.map((item) => (
        <Chip
          key={item.key}
          size="small"
          variant="outlined"
          clickable
          label={item.title}
          onClick={() => onSelectSection(item.key)}
          sx={{
            color: REQUIRED_SECTION_COLORS.required,
            borderColor: REQUIRED_SECTION_COLORS.required,
            bgcolor: "#FFFFFF",
          }}
        />
      ))}
    </Flex>
  );
};

export default RequiredSectionsSummary;
